import { Component, OnInit, ViewChild, type ElementRef, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { SettingsService } from '../../settings/settings.service';
import { Router, ActivatedRoute } from '@angular/router';
import moment from 'moment';
import { CookieService } from 'ngx-cookie-service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { FullLoaderService } from 'src/app/shared/services/full-loader.service';

@Component({
  selector: 'app-buyer-service-purchase-order-list',
  templateUrl: './buyer-service-purchase-order-list.component.html',
  styleUrls: ['./buyer-service-purchase-order-list.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BuyerServicePurchaseOrderListComponent implements OnInit {
  @ViewChild('archivedSection', { static: false })
  archivedSection!: ElementRef;
  @ViewChild('heading', { static: false })
  heading!: ElementRef;
  userId!: number;
  userRole!: string;
  showLoader: boolean = true;
  searchKeyword: string = '';
  AllPOs: any[] = [];
  limit: number = 10;
  offset: number = 0;
  archivedLimit: number = 10;
  archivedOffset: number = 0;
  totalRecords: number = 0;
  archivedTotalRecords: number = 0;
  sortField: string = '';
  sortDirection: string = '';
  docStatus: string = 'all';
  fromDate: any;
  toDate: any;
  selectedPODetails: number[] = [];
  documentData: any[] = [];
  archivedDocumentData: any[] = [];
  isArchivedExpand: boolean = false;
  searchParam: string = '';
  selectedPO: number[] = [];
  selectedArchivedPO: number[] = [];
  archivedLoaded: boolean = false;
  dropdownOpen: boolean = false;
  poTypeDropdownOpen: boolean = false;
  buyerUsersList: any[] = [];
  selectedUsers: any[] = [];
  useroffset: number = 0;
  userlimit: number = 10;
  isLoading: boolean = false;

  statusColors: { [key: string]: string } = {
    Approved: '#0D8000',
    Submitted: '#FFA600',
    Draft: '#003BFF',
    Rejected: '#FF0000',
  };

  filterStatuses = [
    { name: 'Accepted', label: 'Order' },
    { name: 'Sent', label: 'Order' },
    { name: 'Draft', label: 'Order' },
    { name: 'Rejected', label: 'Order' },
    { name: 'ALL', label: 'Order' },
  ];

  filterStatusesRfqAndQuote = [
    { name: 'Submitted', label: 'RFQ' },
    { name: 'Draft', label: 'RFQ' },
    { name: 'Expired', label: 'RFQ' },
    { name: 'Cancelled', label: 'RFQ' },
    { name: 'Accepted', label: 'Quote' },
    { name: 'Pending', label: 'Quote' },
    { name: 'Rejected', label: 'Quote' }
  ];

  items = [
    { label: 'Expected Delivery Date', prop: 'expectedDeliveryDate', selected: false },
    { label: 'Vessel ETA', prop: 'vesselEta', selected: false },
    { label: 'Vessel ETD', prop: 'vesselEtd', selected: false },
    { label: 'Owner', prop: 'Owner', selected: false },
  ];

  archivedItems = [
    { label: 'Expected Delivery Date', prop: 'expectedDeliveryDate', selected: false },
    { label: 'Vessel ETA', prop: 'vesselEta', selected: false },
    { label: 'Vessel ETD', prop: 'vesselEtd', selected: false },
    { label: 'Owner', prop: 'Owner', selected: false },
  ];

  activeIndex: number = this.filterStatuses.length - 1;
  selectedStatus: string = 'ALL';

  previewSection = false;
  previewDocs: string[] = [];

  showContactPopup: boolean = false;
  selectedSupplier: any = {
    companyName: 'N/A',
    contactPerson: 'N/A',
    email: 'N/A',
    phone: 'N/A',
    address: 'N/A',
    fax: 'N/A'
  };

  selectedColumns: { label: string; prop: string }[] = [];
  archivedSelectedColumns: { label: string; prop: string }[] = [];

  constructor(
    private SettingsService: SettingsService,
    private router: Router,
    private cookieService: CookieService,
    private snack: MatSnackBar,
    private iconRegistry: MatIconRegistry,
    private fullLoaderService: FullLoaderService,
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
  ) {
    iconRegistry.addSvgIcon(
      'downloadExcel',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        `${environment.assetsLink}images/excel.svg`
      )
    );
  }

  async ngOnInit() {
    this.userId = Number(this.cookieService.get('userId'));
    this.userRole = this.cookieService.get('userRole');

    this.route.queryParams.subscribe((params) => {
      const statusParam = params['selectedStatus'];
      const labelParam = params['label'];

      if (statusParam && labelParam) {
        this.selectedStatus = statusParam;
        this.docStatus = statusParam;
        if (this.docStatus == 'Draft') {
          this.activeIndex = 2;
        } else if (this.docStatus == 'Sent') {
          this.activeIndex = 1;
        }
      } else {
        this.docStatus = 'ALL';
        this.selectedStatus = 'ALL';
      }
    });
    await this.fetchAllDocuments();
    await this.fetchUsers();
  }

  // ===== FETCH ACTIVE DOCUMENTS =====
  async fetchAllDocuments() {
    const fromDate = this.fromDate
      ? moment(this.fromDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      : null;
    const toDate = this.toDate
      ? moment(this.toDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      : null;

    try {
      this.showLoader = true;
      this.fullLoaderService.showLoader();

      const response = await this.SettingsService.fetchAllServicePurchaseOrderByBuyerId({
        filterValue: this.searchParam,
        buyerId: Number(this.cookieService.get('userId')),
        docStatus: this.docStatus,
        fromDate,
        toDate,
        sortField: this.sortField,
        sortDir: this.sortDirection,
        limit: this.limit,
        offset: this.offset,
        isActive: 1,
      });

      if (response && Array.isArray(response.rows)) {
        const enrichedRows = response.rows.map((row: any) => {
          const r = { ...row };
          r.id = r.id ?? r.purchaseOrderId;
          r.statusColor = this.statusColors?.[r.docStatus] || '#727272';
          r.rfqDateFormatted = r.rfqDate ? moment(r.rfqDate).format('DD/MM/YYYY') : '-';
          if (typeof r.suppliers === 'string') {
            try { r.suppliers = JSON.parse(r.suppliers); } catch { r.suppliers = []; }
          }
          if (typeof r.poAttachment === 'string') {
            try { r.poAttachment = JSON.parse(r.poAttachment); } catch { r.poAttachment = []; }
          }
          return r;
        });

        this.documentData = enrichedRows;
        this.totalRecords = response.totalElements || 0;
      }

      this.showLoader = false;
      this.fullLoaderService.hideLoader();
      this.cdr.markForCheck();
    } catch (error) {
      console.error('Error fetching service purchase orders', error);
      this.showLoader = false;
      this.fullLoaderService.hideLoader();
      this.cdr.markForCheck();
    }
  }

  // ===== FETCH ARCHIVED DOCUMENTS =====
  async fetchArchivedAllDocuments() {
    const fromDate = this.fromDate
      ? moment(this.fromDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      : null;
    const toDate = this.toDate
      ? moment(this.toDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      : null;

    try {
      const response = await this.SettingsService.fetchAllServicePurchaseOrderByBuyerId({
        filterValue: this.searchParam,
        buyerId: Number(this.cookieService.get('userId')),
        docStatus: this.docStatus,
        fromDate,
        toDate,
        sortField: this.sortField,
        sortDir: this.sortDirection,
        limit: this.archivedLimit,
        offset: this.archivedOffset,
        isActive: 0,
      });

      if (response && Array.isArray(response.rows)) {
        const enrichedRows = response.rows.map((row: any) => {
          const r = { ...row };
          r.id = r.id ?? r.purchaseOrderId;
          r.statusColor = this.statusColors?.[r.docStatus] || '#727272';
          r.rfqDateFormatted = r.rfqDate ? moment(r.rfqDate).format('DD/MM/YYYY') : '-';
          if (typeof r.suppliers === 'string') {
            try { r.suppliers = JSON.parse(r.suppliers); } catch { r.suppliers = []; }
          }
          if (typeof r.poAttachment === 'string') {
            try { r.poAttachment = JSON.parse(r.poAttachment); } catch { r.poAttachment = []; }
          }
          return r;
        });

        this.archivedDocumentData = enrichedRows;
        this.archivedTotalRecords = response.totalElements || 0;
      }

      this.archivedLoaded = true;
      this.cdr.markForCheck();
    } catch (error) {
      console.error('Error fetching archived service purchase orders', error);
      this.cdr.markForCheck();
    }
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  togglePoTypeDropdown() {
    this.poTypeDropdownOpen = !this.poTypeDropdownOpen;
  }

  navigateToPoType(type: string) {
    if (type === 'product') {
      this.router.navigate(['/operations/purchase-order-list']);
    }
    this.poTypeDropdownOpen = false;
  }

  onPageChange(event: any) {
    this.offset = event.offset;
    this.fetchAllDocuments();
  }

  onSearch() {
    this.offset = 0;
    this.archivedOffset = 0;
    this.fetchAllDocuments();
  }

  onSort(event: any) {
    const sort = event.sorts[0];
    this.sortField = sort.prop;
    this.sortDirection = sort.dir;
    this.fetchAllDocuments();
  }

  onArchivedSort(event: any) {
    const sort = event.sorts[0];
    this.sortField = sort.prop;
    this.sortDirection = sort.dir;
    this.fetchArchivedAllDocuments();
  }

  onArchivedPageChange(event: any) {
    this.archivedOffset = event.offset;
    this.fetchArchivedAllDocuments();
  }

  toggleArchived() {
    this.isArchivedExpand = !this.isArchivedExpand;
    if (this.isArchivedExpand && this.heading) {
      this.heading.nativeElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
      setTimeout(() => {
        if (this.archivedSection) {
          this.heading.nativeElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
      }, 100);
      if (!this.archivedLoaded) {
        this.fetchArchivedAllDocuments();
        this.archivedLoaded = true;
      }
    }
  }

  cancelFilter() {
    this.docStatus = 'all';
    this.fromDate = null;
    this.toDate = null;
    this.searchParam = '';
    this.offset = 0;
    this.archivedOffset = 0;
    this.fetchAllDocuments();
    this.fetchArchivedAllDocuments();
  }

  toggleSelectAll(event: any, section: string) {
    const checked = event.target.checked;

    if (section == 'active') {
      if (checked) {
        this.selectedPO = this.documentData.map((item) => item.purchaseOrderId);
        this.selectedPODetails = this.selectedPO;
      } else {
        this.selectedPO = [];
      }
    } else {
      if (checked) {
        this.selectedArchivedPO = this.archivedDocumentData.map(
          (item) => item.purchaseOrderId
        );
      } else {
        this.selectedArchivedPO = [];
      }
    }
  }

  selectDeselectPO(
    event: any,
    poDetailsId: any,
    poId: any,
    section: string,
    owner: any
  ) {
    const checked = event.target.checked;

    if (section == 'active') {
      if (checked) {
        this.selectedPO.push(poId);
        this.selectedPODetails.push(poDetailsId);
        if (owner !== '-' && owner !== null) {
          this.snack.open(`User is already assigned to PO ID ${poId}`, 'OK', {
            duration: 5000,
          });
        }
      } else {
        this.selectedPO = this.selectedPO.filter((id) => id !== poId);
        this.selectedPODetails = this.selectedPODetails.filter(
          (id) => id !== poDetailsId
        );
      }
    } else {
      if (checked) {
        this.selectedArchivedPO.push(poId);
      } else {
        this.selectedArchivedPO = this.selectedArchivedPO.filter(
          (id) => id !== poDetailsId
        );
      }
    }
  }

  isChecked(poId: number, section: string) {
    if (section == 'active') {
      return this.selectedPO.includes(poId);
    } else {
      return this.selectedArchivedPO.includes(poId);
    }
  }

  getStatusColor(status: string): string {
    return this.statusColors[status] || '#000000';
  }

  setRowClass = (row: any) => {
    return 'green-row-background';
  };

  onStatusSelect(status: string, index: number, label: string) {
    if (label === 'RFQ') {
      this.router.navigate(['/operations/buyer-service-rfq-list'], {
        queryParams: {
          selectedStatus: status,
          label: label,
        },
      });
    } else if (label === 'Quote') {
      this.router.navigate(['/operations/buyer-service-quote-list'], {
        queryParams: {
          selectedStatus: status,
          label: label,
        },
      });
    } else if (label === 'Order') {
      if (this.selectedStatus.includes(status)) {
        return;
      }
      this.activeIndex = index;
      this.selectedStatus = status;
      this.offset = 0;
      this.docStatus = status;
      this.fetchAllDocuments();
    }
  }

  async purchaseOrderOperation(operation: string) {
    if (operation === 'unarchive') {
      if (this.selectedArchivedPO.length === 0) {
        this.snack.open('Please select atleast one', 'OK', { duration: 3000 });
        return;
      }
      this.showLoader = true;
      await this.SettingsService.servicePurchaseOrderListOperations({
        operation,
        selectedPOId: this.selectedArchivedPO,
      });
      this.snack.open('Items unarchived', 'OK', { duration: 3000 });
    } else {
      if (this.selectedPO.length === 0) {
        this.snack.open('Please select atleast one.', 'OK', { duration: 3000 });
        return;
      }
      const data = { operation, selectedPOId: this.selectedPODetails };
      if (operation === 'archive') {
        this.showLoader = true;
        await this.SettingsService.servicePurchaseOrderListOperations(data);
        this.snack.open('Items archived', 'OK', { duration: 3000 });
      }
    }
    await this.fetchAllDocuments();
    if (this.archivedLoaded) await this.fetchArchivedAllDocuments();
    this.selectedArchivedPO = [];
    this.selectedPO = [];
    this.selectedPODetails = [];
    this.showLoader = false;
    this.cdr.markForCheck();
  }

  async RestorePo(isConfirmed: boolean, row: any) {
    if (!isConfirmed) {
      this.snack.open('Restore operation was canceled.', 'OK', { duration: 3000 });
      return;
    }
    try {
      this.showLoader = true;
      await this.SettingsService.servicePurchaseOrderListOperations({
        operation: 'unArchive',
        selectedPOId: [row.purchaseOrderId],
      });
      this.snack.open('PO has been restored successfully!', 'OK', { duration: 3000 });
      await this.fetchAllDocuments();
      await this.fetchArchivedAllDocuments();
    } catch (error) {
      console.error('Error while restoring PO:', error);
      this.snack.open('Failed to restore PO. Please try again.', 'OK', { duration: 3000 });
    } finally {
      this.showLoader = false;
      this.cdr.markForCheck();
    }
  }

  updateSelectedColumns() {
    this.selectedColumns = this.items
      .filter((item) => item.selected)
      .map((item) => ({ label: item.label, prop: item.prop }));
  }

  toggleSelection(item: any) {
    item.selected = !item.selected;
    this.updateSelectedColumns();
  }

  archivedToggleSelection(item: any) {
    item.selected = !item.selected;
    this.updateArchivedSelectedColumns();
  }

  updateArchivedSelectedColumns() {
    this.archivedSelectedColumns = this.archivedItems
      .filter((item) => item.selected)
      .map((item) => ({ label: item.label, prop: item.prop }));
  }

  isDate(value: any): boolean {
    return value instanceof Date || !isNaN(Date.parse(value));
  }

  formatDate(date: any): string {
    if (!date) return '';
    return moment(date).format('DD/MM/YYYY');
  }

  openPOPreview(row: any) {
    const serviceRfqId = row?.buyerRfqDetailsId;
    const quoteId = row?.quoteId;
    const purchaseOrderId = row?.purchaseOrderId;
    this.router.navigate(['operations', 'createServiceOrder', 'preview'], {
      queryParams: { servicePurchaseOrderId: purchaseOrderId, serviceRfqId, quoteId },
    });
  }

  openRfqDetails(rfqId: number) {
    this.router.navigate(['/operations/createServiceOrder/header'], {
      queryParams: { serviceRfqId: rfqId },
    });
  }

  toggleContactPopUp(value: boolean, row?: any) {
    if (value && row) {
      this.selectedSupplier = {
        companyName: row.supplietCompanyName || row.suppliers?.[0]?.supplierName || 'N/A',
        contactPerson: row.supplierContact || 'N/A',
        email: row.supplierCompanyEmailId || 'N/A',
        phone: row.supplierCompanyPhoneNumber || 'N/A',
        address: row.supplierCompanyAddress || 'N/A',
        fax: row.supplierCompanyFax || 'N/A',
      };
    }
    this.showContactPopup = value;
    this.cdr.markForCheck();
  }

  togglePreview(value: boolean, row?: any) {
    if (value && row) {
      const attachments = row.poAttachment || [];
      this.previewDocs = Array.isArray(attachments)
        ? attachments.map((att: any) => att.url || att.s3Path).filter(Boolean)
        : [];
    }
    this.previewSection = value;
    this.cdr.markForCheck();
  }

  // ===== EXPORT ALL =====
  async fetchAllPOs() {
    try {
      const fromDate = this.fromDate
        ? moment(this.fromDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
        : null;
      const toDate = this.toDate
        ? moment(this.toDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
        : null;

      const response = await this.SettingsService.fetchAllServicePurchaseOrderByBuyerId({
        filterValue: this.searchParam,
        buyerId: Number(this.cookieService.get('userId')),
        docStatus: this.docStatus,
        fromDate,
        toDate,
        sortField: this.sortField,
        sortDir: this.sortDirection,
        limit: this.limit,
        offset: this.offset,
        isActive: 1,
        operationType: 'export',
      });

      if (response && Array.isArray(response.rows)) {
        this.AllPOs = response.rows.map((row: any) => {
          if (typeof row.suppliers === 'string') {
            try { row.suppliers = JSON.parse(row.suppliers); } catch { row.suppliers = []; }
          }
          return row;
        });
      }
    } catch (error) {
      console.error('Error fetching all POs:', error);
      throw error;
    }
  }

  async exportAllPOs() {
    try {
      this.fullLoaderService.showLoader('Exporting PO Details...');
      await this.fetchAllPOs();

      if (!this.AllPOs || this.AllPOs.length === 0) {
        alert('No POs available to export.');
        return;
      }

      const exportData: any[] = [];

      this.AllPOs.forEach((row: any, index: number) => {
        const flattenedProduct = {
          'Sr. No.': index + 1,
          'PO Number': row.purchaseOrderRefNumber,
          'RFQ Reference': row.rfqRefNumber || '',
          'Quote Number': row.quoteRefNumber || '',
          'Port Name': row.portName || '',
          'Vessel Name': row.vesselName || '',
          'Supplier Name': row.suppliers?.[0]?.supplierName || '',
          'Status':
            row.purchaseOrderStatusValue === 'Submitted' ? 'Sent' : row.purchaseOrderStatusValue || '',
          'RFQ Date': row.rfqDate || '',
          'Purchase Order Date': row.purchaseOrderDate || '',
          'Expected Delivery Date': row.expectedDeliveryDate || '',
          'PO Drafted On': row.purchaseOrderStatusValue === 'Draft' ? row.poDraftDate : '',
          'Quote Valid Until': row.quotedByDate || '',
          'PO Rejected Date': row.purchaseOrderStatusValue === 'Rejected' ? row.poDraftDate : '',
          'Vessel ETA': row.vesselEta || '',
          'Vessel ETD': row.vesselEtd || '',
        };
        exportData.push(flattenedProduct);
      });

      const today = new Date();
      const formattedDate = `${String(today.getDate()).padStart(2, '0')}-${String(today.getMonth() + 1).padStart(2, '0')}-${today.getFullYear()}`;
      const fileName = `Buyer_Service_POs_List_${formattedDate}.xlsx`;

      const XLSXMod: any = await import('xlsx');
      const XLSXlib: any = (XLSXMod && (XLSXMod as any).utils)
        ? XLSXMod
        : (XLSXMod as any).default || XLSXMod;
      const ws = XLSXlib.utils.json_to_sheet(exportData);
      const wb = XLSXlib.utils.book_new();
      XLSXlib.utils.book_append_sheet(wb, ws, 'POs');
      XLSXlib.writeFile(wb, fileName);

      this.snack.open('POs data exported successfully!', 'OK', { duration: 5000 });
    } catch (error) {
      console.error('Error while exporting POs:', error);
      this.snack.open('Failed to export POs data.', 'OK', { duration: 5000 });
    } finally {
      this.fullLoaderService.hideLoader();
    }
  }

  // ===== DOWNLOAD PO AS PDF =====
  async downloadPO(purchaseOrderId: number, refNumber: string) {
    this.fullLoaderService.showLoader();
    try {
      const pdf = await this.SettingsService.generateServicePoPdf({
        purchaseOrderId: Number(purchaseOrderId),
      });

      const uint8Array = new Uint8Array(pdf.data);
      const blob = new Blob([uint8Array], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = refNumber + '.pdf';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error('Error downloading PO PDF:', error);
      this.snack.open('Failed to download PO PDF.', 'OK', { duration: 3000 });
    } finally {
      this.fullLoaderService.hideLoader();
    }
  }

  // ===== DOWNLOAD PO AS EXCEL =====
  async generatePoExcel(purchaseOrderId: number, refNumber: string) {
    this.fullLoaderService.showLoader();
    try {
      const fileName = refNumber + '.xlsx';
      const result = await this.SettingsService.fetchServicePoAttachmentExcelData({
        purchaseOrderId: Number(purchaseOrderId),
      });

      const data = {
        purchaseOrderDetails: result.pdfData.purchaseOrder,
        buyerDetails: {
          name: result.pdfData.buyer?.company?.name,
          address: result.pdfData.buyer?.company?.address,
          contact: result.pdfData.buyer?.contact?.person,
          phone: result.pdfData.buyer?.company?.phone,
          email: result.pdfData.buyer?.contact?.email,
          billingAddress: result.pdfData.termsAndConditions?.billingAddress,
        },
        supplierDetails: {
          name: result.pdfData.supplier?.companyName,
          address: result.pdfData.supplier?.address,
          contact: result.pdfData.supplier?.contactName,
          phone: result.pdfData.supplier?.phone,
          email: result.pdfData.supplier?.email,
        },
        freightForwarderDetails: {
          PIC: result.pdfData.freightForwarder?.pic,
          phone: result.pdfData.freightForwarder?.phone,
          fax: result.pdfData.freightForwarder?.fax,
          email: result.pdfData.freightForwarder?.email,
          address: result.pdfData.freightForwarder?.address,
        },
        portAgentDetails: {
          name: result.pdfData.portAgent?.portAgencyName,
          phone: result.pdfData.portAgent?.phoneNumber,
          fax: result.pdfData.portAgent?.phoneFax,
          email: result.pdfData.portAgent?.contact,
          contact: result.pdfData.portAgent?.contact,
        },
        costSummary: {
          lineItemSubtotal: parseFloat(result.pdfData.priceDetails?.subtotal || 0).toFixed(3),
          generalDiscountType: result.pdfData.priceDetails?.generalDiscount?.type || 'percentage',
          generalDiscountValue: parseFloat(result.pdfData.priceDetails?.generalDiscount?.value || 0),
          generalDiscountAmount: (result.pdfData.priceDetails?.generalDiscount?.type || 'percentage') === 'percentage'
            ? (parseFloat(result.pdfData.priceDetails?.subtotal || 0) * parseFloat(result.pdfData.priceDetails?.generalDiscount?.value || 0) / 100).toFixed(3)
            : parseFloat(result.pdfData.priceDetails?.generalDiscount?.value || 0).toFixed(3),
          taxAmount: parseFloat(result.pdfData.priceDetails?.taxAmount || 0).toFixed(3),
          otherCharges: result.pdfData.priceDetails?.freight || [],
          totalAdditionalCost: result.pdfData.priceDetails?.freightTotal,
          currency: result.pdfData.priceDetails?.currency?.currencyCode || '',
          grandTotal: parseFloat(result.pdfData.priceDetails?.total || 0).toFixed(3),
        },
        vesselDetails: result.pdfData.vessel,
        portDetails: result.pdfData.port,
        priceDetails: result.pdfData.priceDetails,
        incotermDetails: result.pdfData.incotermDetails || {},
        taxDetails: result.pdfData.taxDetails || {},
        termsAndConditions: result.pdfData.termsAndConditions,
        lineItems: (result.pdfData.lineItems || []).map((item: any, index: number) => ({
          srNo: index + 1,
          serviceName: item.serviceName,
          serviceDescription: item.serviceDescription,
          quantity: item.quantity,
          unitCost: item.unitCost,
          discount: item.discount,
          discountedUnitCost: item.discountedUnitPrice,
          totalCost: item.totalCost,
        })),
      };

      const labelMap: Record<string, string> = {
        name: 'Name', address: 'Address', contact: 'Contact', phone: 'Phone',
        fax: 'Fax', email: 'Email', billingAddress: 'Billing Address', PIC: 'PIC',
      };

      const Excel = await import('exceljs');
      const workbook = new Excel.Workbook();
      const ws = workbook.addWorksheet('Service Purchase Order');

      // === TITLE ===
      ws.mergeCells('A1:G1');
      const title = ws.getCell('A1');
      title.value = 'Service Purchase Order';
      title.font = { size: 18, bold: true, color: { argb: '1F4E78' } };
      title.alignment = { horizontal: 'center', vertical: 'middle' };
      ws.addRow([]);

      // === PO DETAILS ===
      const poHeader = ws.addRow(['SERVICE PURCHASE ORDER DETAILS']);
      poHeader.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'D9E1F2' } };
      poHeader.getCell(1).font = { bold: true };
      ws.addRow([]);

      const poInfo = [
        ['Purchase Order Number:', data.purchaseOrderDetails?.purchaseOrderRefNumber, '', 'Expected Delivery Date:', data.purchaseOrderDetails?.expectedDeliveryDate],
        ['Order Date:', data.purchaseOrderDetails?.purchaseOrderDate, '', 'Incoterms:', data.incotermDetails?.incotermCode || ''],
        ['Quotation Number:', data.purchaseOrderDetails?.quoteRefNumber, '', 'Incoterms Location:', data.incotermDetails?.locations || ''],
        ['Quotation Date:', data.purchaseOrderDetails?.quotationDate, '', 'Vessel Name:', data.vesselDetails?.name],
        ['Payment Terms:', data.termsAndConditions?.buyersPaymentTerms, '', 'Port Name:', data.portDetails?.name],
      ];
      poInfo.forEach((r) => {
        const row = ws.addRow(r);
        row.eachCell((c) => (c.alignment = { vertical: 'middle' }));
      });
      ws.addRow([]);

      // === BUYER + SUPPLIER DETAILS ===
      const bsHeader = ws.addRow(['Buyer Details', '', '', 'Supplier Details']);
      bsHeader.eachCell(c => {
        c.font = { bold: true };
        c.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF2CC' } };
      });
      ws.addRow([]);

      const buyerEntries = Object.entries(data.buyerDetails).map(([key, value]) => [
        labelMap[key] || key.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase()), value
      ]);
      const supplierEntries = Object.entries(data.supplierDetails || {}).map(([key, value]) => [
        labelMap[key] || key.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase()), value
      ]);
      const bmaxRows = Math.max(buyerEntries.length, supplierEntries.length);
      const paddedBuyer = [...buyerEntries, ...Array(bmaxRows - buyerEntries.length).fill(['', ''])];
      const paddedSupplier = [...supplierEntries, ...Array(bmaxRows - supplierEntries.length).fill(['', ''])];
      for (let i = 0; i < bmaxRows; i++) {
        ws.addRow([paddedBuyer[i][0], paddedBuyer[i][1], '', paddedSupplier[i][0], paddedSupplier[i][1]]);
      }
      ws.addRow([]);

      // === FREIGHT FORWARDER + PORT AGENT ===
      const faHeader = ws.addRow(['Freight Forwarder Details', '', '', 'Port Agent Details']);
      faHeader.eachCell(c => {
        c.font = { bold: true };
        c.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'E2EFDA' } };
      });
      ws.addRow([]);

      const freightEntries = Object.entries(data.freightForwarderDetails).map(([key, value]) => [
        labelMap[key] || key.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase()), value
      ]);
      const portAgentEntries = Object.entries(data.portAgentDetails || {}).map(([key, value]) => [
        labelMap[key] || key.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase()), value
      ]);
      const maxRows = Math.max(freightEntries.length, portAgentEntries.length);
      const paddedFreight = [...freightEntries, ...Array(maxRows - freightEntries.length).fill(['', ''])];
      const paddedPortAgent = [...portAgentEntries, ...Array(maxRows - portAgentEntries.length).fill(['', ''])];
      for (let i = 0; i < maxRows; i++) {
        ws.addRow([paddedFreight[i][0], paddedFreight[i][1], '', paddedPortAgent[i][0], paddedPortAgent[i][1]]);
      }
      ws.addRow([]);

      // === LINE ITEMS ===
      const liHeader = ws.addRow(['Line Items']);
      liHeader.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'BDD7EE' } };
      liHeader.getCell(1).font = { bold: true };
      ws.addRow([]);

      const tableHeader = ws.addRow([
        'Sr. No', 'Service Name', 'Service Description', 'Quantity',
        'Unit Cost', 'Discount', 'Discounted Unit Cost', 'Total Cost'
      ]);
      tableHeader.eachCell((cell) => {
        cell.font = { bold: true };
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'D9D9D9' } };
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      });

      data.lineItems.forEach((item: any) => {
        const row = ws.addRow([
          item.srNo, item.serviceName, item.serviceDescription, item.quantity,
          item.unitCost, item.discount, item.discountedUnitCost, item.totalCost
        ]);
        row.eachCell((cell) => {
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
          cell.alignment = { wrapText: true, vertical: 'middle' };
        });
      });
      ws.addRow([]);

      // === COST SUMMARY ===
      const csHeader = ws.addRow(['Cost Summary']);
      csHeader.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'F9F9F9' } };
      csHeader.getCell(1).font = { bold: true };
      ws.addRow([]);

      const csTableHeader = ws.addRow(['Description', 'Amount']);
      csTableHeader.eachCell((cell) => {
        cell.font = { bold: true };
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'D9D9D9' } };
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      });

      const addCostRow = (label: string, value: any, bold = false) => {
        const row = ws.addRow([label, value]);
        row.eachCell((cell) => {
          if (bold) cell.font = { bold: true };
          cell.alignment = { horizontal: 'center', vertical: 'middle' };
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        });
      };

      addCostRow('Line Total Amount', data.costSummary.lineItemSubtotal);
      if (parseFloat(data.costSummary.generalDiscountAmount) > 0) {
        addCostRow('General Discount Amount', data.costSummary.generalDiscountAmount);
      }

      let totalAdditionalCharges = 0;
      (data.costSummary.otherCharges || []).forEach((charge: any) => {
        addCostRow(charge.description, charge.value);
        totalAdditionalCharges += Number(charge.value || 0);
      });
      addCostRow('Total Additional Cost', totalAdditionalCharges, true);

      if (parseFloat(data.costSummary.taxAmount) > 0) {
        addCostRow('Tax Amount', data.costSummary.taxAmount);
      }
      addCostRow('Grand Total', `${data.costSummary.grandTotal} ${data.costSummary.currency}`, true);
      ws.addRow([]);

      // === TERMS AND CONDITIONS ===
      const termsHeader = ws.addRow(['Terms And Conditions']);
      termsHeader.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FCE4D6' } };
      termsHeader.getCell(1).font = { bold: true };
      ws.addRow([]);
      ws.addRow([data.termsAndConditions?.text]);
      ws.addRow([]);

      // === FROM/TO ===
      ws.addRow(['From VSMPS Buyer:']);
      ws.addRow([data.buyerDetails.name]);
      ws.addRow([data.buyerDetails.address]);
      ws.addRow([]);
      ws.addRow(['To VSMPS Supplier:']);
      ws.addRow([data.supplierDetails.name]);
      ws.addRow([data.supplierDetails.address]);
      ws.addRow([]);
      ws.addRow(['Copyright © Varuna Sentinels BV. All rights reserved.']);

      // === AUTO WIDTH ===
      const colCount = ws.actualColumnCount;
      for (let i = 1; i <= colCount; i++) {
        let maxLen = 12;
        ws.eachRow({ includeEmpty: true }, (r) => {
          const val = r.getCell(i).value;
          const len = val ? val.toString().length : 0;
          if (len > maxLen) maxLen = len;
        });
        ws.getColumn(i).width = Math.min(maxLen + 4, 40);
      }

      workbook.xlsx.writeBuffer().then(async (buffer) => {
        const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const fileSaverMod = await import('file-saver');
        const saveAs = (fileSaverMod as any).saveAs || (fileSaverMod as any).default;
        saveAs(blob, fileName);
      });
    } catch (error) {
      console.error('Error generating PO Excel:', error);
      this.snack.open('Failed to generate PO Excel.', 'OK', { duration: 3000 });
    } finally {
      this.fullLoaderService.hideLoader();
    }
  }

  // ===== INVITE USER =====
  alreadyAssignedBuyerUsers() {
    const alreadyAssignedPOs = this.selectedPO
      .map((poId: any) => {
        const po = this.documentData.find((data: any) => data.purchaseOrderId === poId);
        return po && po.buyerUserName ? po.purchaseOrderId : null;
      })
      .filter((poId: any) => poId !== null);

    if (alreadyAssignedPOs.length > 0) {
      const poIds = alreadyAssignedPOs.join(', ');
      this.snack.open(`User is already assigned to PO IDs: ${poIds}`, 'OK', {
        duration: 5000,
      });
      return;
    }
  }

  async toggleUserSelection(item: any) {
    if (this.selectedPO.length === 0) {
      this.snack.open('Please select at least one PO before selecting a user.', 'OK', {
        duration: 3000,
      });
      return;
    }

    item.selected = !item.selected;

    if (item.selected) {
      try {
        this.showLoader = true;
        await this.SettingsService.assignServicePOToBuyerUser(
          this.selectedPO,
          item.id
        );
        await this.fetchAllDocuments();
        this.selectedPO = [];
        item.selected = false;
        this.showLoader = false;
        this.snack.open('User assigned to Service PO successfully.', 'OK', {
          duration: 3000,
        });
      } catch (error) {
        this.showLoader = false;
        this.snack.open('Failed to assign user to Service PO.', 'OK', {
          duration: 3000,
        });
        throw error;
      }
    }
  }

  onScroll(): void {
    const menuContent = document.querySelector('.menu-content') as HTMLElement;
    if (
      menuContent.scrollTop + menuContent.clientHeight >= menuContent.scrollHeight &&
      !this.isLoading
    ) {
      if (this.buyerUsersList.length == this.userlimit * this.useroffset) {
        this.fetchUsers();
      } else {
        this.isLoading = false;
      }
    }
  }

  async fetchUsers(): Promise<void> {
    this.isLoading = true;
    try {
      const response = await this.SettingsService.fetchUserBySupplierId(
        Number(this.cookieService.get('userId')),
        this.userlimit,
        this.useroffset
      ).toPromise();

      if (response && Array.isArray(response.rows)) {
        this.buyerUsersList = [...this.buyerUsersList, ...response.rows];
        this.useroffset++;
      }
    } catch (error) {
      console.error('Error fetching buyer users:', error);
    } finally {
      this.isLoading = false;
    }
  }
}
